module.exports = __webpack_public_path__ + "img/zizhi3.162c95bc.png";